import { render } from "./AddDepotPage.vue?vue&type=template&id=386a931d&ts=true"
import script from "./AddDepotPage.vue?vue&type=script&lang=ts"
export * from "./AddDepotPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__